<script setup lang="ts">
  import { BackButton } from '@/shared/ui/components'

  import OfficeCreate from '@/views/admin/offices/Create.vue'
  definePage({
    meta: {
      layout: 'admin',
    },
  })
</script>

<template>
  <div class="head">
    <div class="flex items-center gap-4">
      <BackButton
        :route="{
          name: '/admin/offices/',
        }"
        type="rounded"
      />
      <h2 class="text-2xl font-bold">{{ $t('admin_offices_new_title') }}</h2>
    </div>
  </div>
  <div class="content mt-4">
    <OfficeCreate />
  </div>
</template>
